//
//
//
//
//
//
//
//
//
//
//
import Parvacy from "./pravacy.vue";
import Reg from "./reg.vue";
import MasterButtom from "../../components/MasterButtom";
export default {
  name: "regist",
  components: {
    Parvacy: Parvacy,
    Reg: Reg,
    MasterButtom: MasterButtom
  },
  data: function data() {
    return {
      num: false
    };
  },
  deactivated: function deactivated() {
    this.num = false;
  },
  mounted: function mounted() {}
};